import ExtendedPath from "csi/core/ExtendedPath";
import { cnl } from "csi/typings";
import declare from "dojo/_base/declare";
import { getAttributeRuleSpecsForType, getColorMatrixPath, PP_RULE_CONTAINER_URL } from "src/ProductPresentation/PPService";
import CustomViewAttributeTable from "src/SiteAdmin/Attributes/CustomViewAttributeTable";

const PPAttributeTable = declare(CustomViewAttributeTable, {

	/** @property {boolean } primaryTypeOnly - indicate if only show the attributes of the primary type */
	matrixTypeOnly: false,

	/** @property {boolean } primaryTypeOnly - indicate if only show the attributes of the primary type */
	primaryTypeOnly: false,

	/** @property {string} typeClass - class type for attributes */
	typeClass: null,

	/**
	 * @override
	 * Get specs async.
	 */
	onBuildDeferreds(ctx, dfds) {
		const { typeClass, primaryTypeOnly, matrixTypeOnly } = this;

		const dfd = getAttributeRuleSpecsForType(typeClass, primaryTypeOnly, matrixTypeOnly, true, this.cacheView);
		dfds.push(dfd);

		dfd.then((specs) => this.specs = specs);
	},

	/**
	 * Compose URL.
	 */
	_composeKeyContainerUrl(type: string): cnl {
		return `${PP_RULE_CONTAINER_URL}/${type}`;
	},

	/**
	 * Get key container url.
	 */
	getKeyContainerUrl(): cnl {
		const type = this.getNodeTypeOfFilteringAttributes();
		return this._composeKeyContainerUrl(type);
	},

	/**
	 * Get matrix path based on the properties configuration.
	 */
	getMatrixPath(): ExtendedPath {
		const { typeClass, matrixTypeOnly } = this;

		if (matrixTypeOnly) {
			return getColorMatrixPath(typeClass);
		}

		return null;
	},

	/**
	 * Get the node type based on the properties configuration.
	 */
	getNodeTypeOfFilteringAttributes(): string {
		const { typeClass } = this;
		const matrixPath = this.getMatrixPath();
		let type = typeClass;

		if (matrixPath) {
			type = matrixPath.getEndType();
		}

		return type;
	},
});

export = PPAttributeTable;